package horcrux.frontend.common

import horcrux.common.api.dtos.types.CollectionName
import horcrux.common.api.dtos.types.DocumentMetadata
import horcrux.common.api.dtos.types.DocumentName
import horcrux.common.utils.invert
import react.StateInstance
import react.useState

open class State<A>(private val initialValue: A) {
    constructor(block: () -> A) : this(block())

    internal val state: StateInstance<A> = useState(initialValue)
    fun reset() = state.set(initialValue)
    fun isReset(): Boolean = get() == initialValue
    fun get(): A = state.get()
    fun set(value: A) = state.set(value)
    fun set(block: () -> A) = set(block())
    fun update(block: (A) -> A) = state.set(block(state.get()))
    suspend fun updateAsync(block: suspend (A) -> A) = state.set(block(state.get()))

    override fun toString(): String =
        "State<${state.component1()}>"
}

class BooleanState(initialValue: Boolean) : State<Boolean>(initialValue) {
    constructor() : this(false)

    fun setTrue() = state.set(true)
    fun setFalse() = state.set(false)

    fun toggle() = state.set(!get())
}

class MaybeState<A>(initialValueMaybe: A?) : State<A?>(initialValueMaybe) {
    constructor() : this(null)

    fun onSome(block: (A) -> Unit): MaybeState<A> {
        get()?.let(block)
        return this
    }

    fun onNone(block: () -> Unit): MaybeState<A> {
        get().invert()?.let { block() }
        return this
    }
}

class MapState<A, B>(initialValue: Map<A, B>) : State<Map<A, B>>(initialValue) {
    constructor() : this(mapOf())
}
